import { render, staticRenderFns } from "./ticket.vue?vue&type=template&id=4749400a&scoped=true&lang=html"
import script from "./ticket.vue?vue&type=script&lang=js"
export * from "./ticket.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4749400a",
  null
  
)

export default component.exports